import {
  Alert,
  IconClockLine,
  IconInfoSolid,
  List,
  Pill,
  Text,
  ToggleDetails,
  ToggleGroup,
  Tooltip,
  View,
} from "@instructure/ui";
import { useTranslation } from "react-i18next";
import { useContext } from "react";
import {
  getFutureVersions,
  getVersionByDate,
  isArchived,
  sortOutcomes,
} from "../../../../components/LearningOutcomes/utils";
import { TermsContext } from "../../../../utils/Context";

const ApprovedOutcomesList = ({ currentSection }) => {
  const { t } = useTranslation();
  const { insightsTerms } = useContext(TermsContext);
  const nonArchivedOutcomes = currentSection?.learning_outcomes?.filter(
    (outcome) => !isArchived(outcome)
  );
  const archivedOutcomes = currentSection?.learning_outcomes?.filter(
    (outcome) => isArchived(outcome)
  );

  const findOutcomeVariant = (outcome) => {
    return (
      outcome?.variants?.length > 0 &&
      new Date(
        outcome.variants.sort(
          (a, b) => new Date(b.last_updated) - new Date(a.last_updated)
        )[0].last_updated
      ) > new Date(outcome.last_updated)
    );
  };

  const findInsightsTerm = (canvasTermId) => {
    let term;
    insightsTerms.forEach((insightsTerm) => {
      insightsTerm.canvas_terms.forEach((canvasTerm) => {
        if (canvasTerm.id === canvasTermId) {
          term = insightsTerm;
        }
      });
    });
    return term;
  };

  return (
    <View position="relative" tabIndex="0" role="button">
      <List isUnstyled>
        {currentSection?.learning_outcomes?.length > 0 ? (
          sortOutcomes(nonArchivedOutcomes).map((outcome, key) => {
            const version = getVersionByDate(
              outcome,
              new Date(currentSection.term.start_at)
            );
            const futureVersions = getFutureVersions(outcome);
            return (
              <List.Item key={key}>
                <div
                  style={{
                    color: "#0D323F",
                    backgroundColor: "#F2F8FA",
                    border: "1px solid #333",
                    borderRadius: "10px",
                    padding: "5px 15px",
                    marginBottom: 10,
                  }}
                >
                  {findOutcomeVariant(version) ? (
                    <Text size="small">
                      {version.variants[0].name && (
                        <Text size="small" weight="bold">
                          {version.variants[0].name}:{" "}
                        </Text>
                      )}
                      {version.variants[0].statement}{" "}
                      <Pill color="info">
                        {t("dashboard.myOutcomeVariant")}
                      </Pill>
                      <ToggleDetails
                        size="small"
                        summary={
                          <Text size="small">
                            {t("dashboard.viewCurrentOutcomeVersion")}
                            <Tooltip
                              renderTip={
                                <div style={{ width: "600px" }}>
                                  {t("dashboard.currentVersionResultsInfo")}
                                </div>
                              }
                              placement="end"
                              on={["click", "hover", "focus"]}
                              color="primary-inverse"
                            >
                              <IconInfoSolid color="brand" />
                            </Tooltip>
                          </Text>
                        }
                      >
                        <Text size="small">
                          {version.name && (
                            <Text size="small" weight="bold">
                              {version.name}:{" "}
                            </Text>
                          )}
                          {version.statement}
                        </Text>
                      </ToggleDetails>
                    </Text>
                  ) : (
                    <Text size="small">
                      {version.name && (
                        <Text size="small" weight="bold">
                          {version.name}:{" "}
                        </Text>
                      )}
                      {version.statement}
                    </Text>
                  )}
                  {futureVersions.length > 0 && (
                    <Tooltip
                      color="primary-inverse"
                      renderTip={
                        <div style={{ maxWidth: 250 }}>
                          {futureVersions.map((futureVersion, key) => (
                            <Text size="small" key={key}>
                              <Text weight="bold" size="small">
                                {
                                  findInsightsTerm(
                                    futureVersion?.effective_term?.ddl_id
                                  )?.name
                                }
                                :{" "}
                              </Text>
                              {futureVersion.statement}
                              <br />
                            </Text>
                          ))}
                        </div>
                      }
                    >
                      <Pill
                        color="info"
                        renderIcon={<IconClockLine />}
                        margin="0 0 0 x-small"
                      >
                        {t("learningOutcomes.upcoming")}
                      </Pill>
                    </Tooltip>
                  )}
                </div>
              </List.Item>
            );
          })
        ) : (
          <List.Item>
            <Alert>{t("dashboard.noApprovedOutcomes")}</Alert>
          </List.Item>
        )}
      </List>
      {archivedOutcomes?.length > 0 && (
        <ToggleGroup
          toggleLabel={t("learningOutcomes.archive.archivedCLOs")}
          summary={t("learningOutcomes.archive.archivedCLOs")}
        >
          <List isUnstyled>
            {archivedOutcomes.map((outcome, key) => (
              <List.Item key={key}>
                <div
                  style={{
                    color: "#0D323F",
                    backgroundColor: "#F2F8FA",
                    border: "1px solid #333",
                    borderRadius: "10px",
                    padding: "5px 15px",
                    margin: 15,
                  }}
                >
                  <Text size="small">
                    {outcome.name && (
                      <Text size="small" weight="bold">
                        {outcome.name}:{" "}
                      </Text>
                    )}
                    {outcome.statement}{" "}
                    <Pill>
                      {t("learningOutcomes.archive.archived")}{" "}
                      {outcome.archive_term.insights_term_id}
                    </Pill>
                  </Text>
                </div>
              </List.Item>
            ))}
          </List>
        </ToggleGroup>
      )}
    </View>
  );
};

export default ApprovedOutcomesList;
